import api from './api';

// ==================== Plans ====================

export const adminService = {
  // Plans
  async getPlans(includeInactive = false) {
    const response = await api.get('/admin/plans', {
      params: { include_inactive: includeInactive },
    });
    return response.data;
  },

  async createPlan(data) {
    const response = await api.post('/admin/plans', data);
    return response.data;
  },

  async updatePlan(planId, data) {
    const response = await api.put(`/admin/plans/${planId}`, data);
    return response.data;
  },

  async deletePlan(planId) {
    await api.delete(`/admin/plans/${planId}`);
  },

  async setDefaultPlan(planId) {
    const response = await api.post(`/admin/plans/${planId}/set-default`);
    return response.data;
  },

  async seedPlans() {
    const response = await api.post('/admin/plans/seed');
    return response.data;
  },

  // Site Content
  async getSiteContent() {
    const response = await api.get('/admin/content');
    return response.data;
  },

  async getContentKeys() {
    const response = await api.get('/admin/content/keys');
    return response.data;
  },

  async createContent(data) {
    const response = await api.post('/admin/content', data);
    return response.data;
  },

  async updateContent(contentId, data) {
    const response = await api.put(`/admin/content/${contentId}`, data);
    return response.data;
  },

  async upsertContentByKey(key, data) {
    const response = await api.put(`/admin/content/key/${key}`, data);
    return response.data;
  },

  async deleteContent(contentId) {
    await api.delete(`/admin/content/${contentId}`);
  },

  async seedContent() {
    const response = await api.post('/admin/content/seed');
    return response.data;
  },

  // API Providers
  async getAPIProviders(includeInactive = false) {
    const response = await api.get('/admin/api-providers', {
      params: { include_inactive: includeInactive },
    });
    return response.data;
  },

  async createAPIProvider(data) {
    const response = await api.post('/admin/api-providers', data);
    return response.data;
  },

  async updateAPIProvider(providerId, data) {
    const response = await api.put(`/admin/api-providers/${providerId}`, data);
    return response.data;
  },

  async deleteAPIProvider(providerId) {
    await api.delete(`/admin/api-providers/${providerId}`);
  },

  async setDefaultAPIProvider(providerId) {
    const response = await api.post(`/admin/api-providers/${providerId}/set-default`);
    return response.data;
  },

  async getAPIUsageSummary(days = 30) {
    const response = await api.get('/admin/api-usage', { params: { days } });
    return response.data;
  },

  async seedAPIProviders() {
    const response = await api.post('/admin/api-providers/seed');
    return response.data;
  },

  // Payments
  async getPayments(days = 30, page = 1, perPage = 50) {
    const response = await api.get('/admin/payments', {
      params: { days, page, per_page: perPage },
    });
    return response.data;
  },

  async getPaymentSummary(days = 30) {
    const response = await api.get('/admin/payments/summary', { params: { days } });
    return response.data;
  },

  async testStripeConnection() {
    const response = await api.post('/admin/payments/test-stripe');
    return response.data;
  },

  // Users (existing endpoints)
  async getUsers(page = 1, perPage = 20, search = '') {
    const response = await api.get('/admin/users', {
      params: { page, per_page: perPage, search: search || undefined },
    });
    return response.data;
  },

  async getUser(userId) {
    const response = await api.get(`/admin/users/${userId}`);
    return response.data;
  },

  async updateUserSubscription(userId, data) {
    const response = await api.put(`/admin/users/${userId}/subscription`, data);
    return response.data;
  },

  async deactivateUser(userId) {
    const response = await api.post(`/admin/users/${userId}/deactivate`);
    return response.data;
  },

  async activateUser(userId) {
    const response = await api.post(`/admin/users/${userId}/activate`);
    return response.data;
  },

  async getStats() {
    const response = await api.get('/admin/stats');
    return response.data;
  },
};

export default adminService;
